import React, { useEffect, useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Hidden,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core"
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded"
import Link from "@material-ui/core/Link"
import InfiniteScroll from "react-infinite-scroll-component"
import { Fragment } from "react"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown"
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp"
import { isEmpty } from "lodash"

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  mobileTableRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: 0,
    paddingRight: "0 !important",
  },
  mobileClientName: { fontSize: "0.8rem", fontWeight: 600 },
  collapseStyles: { boxShadow: "none", border: "none", width: "100%" },
  collapseSummary: {
    width: "100%",
    justifyContent: "space-between",
    margin: 0,
    display: "flex",
  },
  collapseDetails: {
    padding: "0px",
    width: "100%",
    backgroundColor: "#f8f8f8",
  },
  collapseDetailsContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  collapseDetailsRow: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #e0e0e0",
    padding: "10px",
  },
  collapseDetailsLastRow: {
    display: "flex",
    justifyContent: "center",
    padding: "10px",
  },
  collapseSummaryRow: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
})

const pageSize = 50

export default function BasicTable(props) {
  const classes = useStyles()
  const [page, setPage] = useState(1)
  const hasClients = props.clientList && props.clientList.length != 0
  const pagedClients = hasClients && props.clientList.slice(0, page * pageSize)

  useEffect(
    () => {
      setPage(1)
    },
    [JSON.stringify(props.clientList)]
  )
  return (
    <Fragment>
      {/* WEB VIEW */}
      <Hidden smDown>
        <div style={{ margin: "20px", width: "97%" }}>
          <Paper>
            <InfiniteScroll
              next={() => setPage(page + 1)}
              hasMore={props.clientList.length > page * pageSize}
              dataLength={pagedClients.length}
            >
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>GTT</TableCell>
                    <TableCell>ADD</TableCell>
                    <TableCell>First Name</TableCell>
                    <TableCell>Last Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Phone Number</TableCell>
                    <TableCell>Company</TableCell>
                    <TableCell>Notes</TableCell>
                  </TableRow>
                </TableHead>
                {hasClients && (
                  <TableBody>
                    {pagedClients.map((cl, i) => (
                      <TableRow key={i}>
                        <TableCell component="th" scope="row">
                          {cl.gtt == 1 && (
                            <CheckCircleRoundedIcon color="primary" />
                          )}
                        </TableCell>
                        <TableCell>
                          {cl.ad == 1 && (
                            <CheckCircleRoundedIcon color="primary" />
                          )}
                        </TableCell>
                        <TableCell>{cl.first_name}</TableCell>
                        <TableCell>{cl.last_name}</TableCell>
                        <TableCell>{cl.email}</TableCell>
                        <TableCell>{cl.phone}</TableCell>
                        <TableCell>
                          {cl.company_id && !isEmpty(props.companyList)
                            ? props.companyList.find(
                              cm => cm.id === cl.company_id
                            ).name
                            : cl.client}
                        </TableCell>
                        <TableCell>
                          <Link
                            href="#"
                            onClick={() => {
                              props.openClientProfile(cl)
                            }}
                          >
                            View Notes
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>

              {!hasClients && (
                <Box>
                  <Typography variant="h4">No Clients Found</Typography>
                </Box>
              )}
            </InfiniteScroll>
          </Paper>
        </div>
      </Hidden>

      {/* MOBILE VIEW */}
      <Hidden mdUp>
        <div>
          <Paper>
            <InfiniteScroll
              next={() => setPage(page + 1)}
              hasMore={props.clientList.length > page * pageSize}
              dataLength={pagedClients.length}
            >
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                  </TableRow>
                </TableHead>
                {hasClients && (
                  <TableBody>
                    {pagedClients.map((cl, i) => (
                      <TableRow key={i}>
                        <TableCell className={classes.mobileTableRow}>
                          <ExpansionPanel
                            key={i}
                            className={classes.collapseStyles}
                          >
                            <ExpansionPanelSummary
                              className={classes.collapseSummary}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Box
                                component="div"
                                m={1}
                                className={classes.collapseSummaryRow}
                              >
                                <Typography
                                  variant="p"
                                  className={classes.mobileClientName}
                                >
                                  {cl.first_name + " " + cl.last_name}
                                </Typography>
                                <ArrowDropDownIcon />
                              </Box>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails
                              className={classes.collapseDetails}
                            >
                              <Box
                                component="div"
                                m={1}
                                className={classes.collapseDetailsContainer}
                              >
                                <Box
                                  component="div"
                                  m={1}
                                  className={classes.collapseDetailsRow}
                                >
                                  <Typography variant="p">GTT</Typography>
                                  {cl.gtt == 1 && (
                                    <CheckCircleRoundedIcon color="primary" />
                                  )}
                                </Box>
                                <Box
                                  component="div"
                                  m={1}
                                  className={classes.collapseDetailsRow}
                                >
                                  <Typography variant="p">ADD</Typography>
                                  {cl.ad == 1 && (
                                    <CheckCircleRoundedIcon color="primary" />
                                  )}
                                </Box>

                                <Box
                                  component="div"
                                  m={1}
                                  className={classes.collapseDetailsRow}
                                >
                                  <Typography variant="p">Email</Typography>
                                  <Typography variant="p">
                                    {cl.email}
                                  </Typography>
                                </Box>

                                <Box
                                  component="div"
                                  m={1}
                                  className={classes.collapseDetailsRow}
                                >
                                  <Typography variant="p">Phone</Typography>
                                  <Typography variant="p">
                                    {cl.phone}
                                  </Typography>
                                </Box>

                                <Box
                                  component="div"
                                  m={1}
                                  className={classes.collapseDetailsRow}
                                >
                                  <Typography variant="p">Company</Typography>
                                  <Typography variant="p">
                                    {cl.company_id &&
                                      !isEmpty(props.companyList)
                                      ? props.companyList.find(
                                        cm => cm.id === cl.company_id
                                      ).name
                                      : cl.client}
                                  </Typography>
                                </Box>

                                <Box
                                  component="div"
                                  m={1}
                                  className={classes.collapseDetailsLastRow}
                                >
                                  <Link
                                    href="#"
                                    onClick={() => props.openClientProfile(cl)}
                                  >
                                    View Notes
                                  </Link>
                                </Box>
                              </Box>
                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>

              {!hasClients && (
                <Box>
                  <Typography variant="h4">No Clients Found</Typography>
                </Box>
              )}
            </InfiniteScroll>
          </Paper>
        </div>
      </Hidden>
    </Fragment>
  )
}
